import React, { useState } from "react";
import Policies from "./Policy";
import "./Policy.css";
import Sidebar from "./PolicyInformation-Sidebar";
import PartnersDropdown from "./Partner-Dropdown";
import { FaFileAlt } from 'react-icons/fa'; 

export const CustomTable = ({ data, alert }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedPolicy, setSelectedPolicy] = useState(null);
  
  const openSidebar = (policy) => {
    setSelectedPolicy(policy);
    setIsSidebarOpen(true);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
    setSelectedPolicy(null);
  };

 const ProgressRating = ({ value }) => {
  if (value >= 0 && value <= 30) {
    return (
      <span
        className="rating-minimal"
        style={{
          color: '#ff0000',
          fontWeight: 'normal',
          fontSize: '14px',
          padding: '2px 6px',
          borderRadius: '12px',
          backgroundColor: '#ffe0eb', // Light red background for better contrast
        }}
      >
        🔴 Minimal
      </span>
    );
  } else if (value >= 31 && value <= 60) {
    return (
      <span
        className="rating-moderate"
        style={{
          color: '#ff6f61', // Light coral pink for Moderate
          fontWeight: 'normal',
          fontSize: '14px',
          padding: '2px 6px',
          borderRadius: '12px',
          backgroundColor: '#ffe2e0', // Light peach background
        }}
      >
        🟠 Moderate
      </span>
    );
  } else if (value >= 61 && value <= 80) {
    return (
      <span
        className="rating-significant"
        style={{
          color: '#d98f00', // Darker yellow for better contrast
          fontWeight: 'normal',
          fontSize: '14px',
          padding: '2px 6px',
          borderRadius: '12px',
          backgroundColor: '#fff3cd', // Softer yellow background
        }}
      >
        🟡 Significant
      </span>
    );
  } else if (value >= 81 && value <= 100) {
    return (
      <span
        className="rating-satisfactory"
        style={{
          color: '#008000',
          fontWeight: 'normal',
          fontSize: '14px',
          padding: '2px 6px',
          borderRadius: '12px',
          backgroundColor: '#d4edda', // Soft green background
        }}
      >
        🟢 Satisfactory
      </span>
    );
  }
  return value;
};


  return (
    <>
      <div className="table-responsive">
        <table className="table text-sm">
          <thead className="table-header">
            <tr>
              <th className="col-w-lg fix-col">Location</th>
              <th className="col-w-lg fix-col-1">Policy Name</th>
              <th className="col-w-lg">Systems</th>
              <th className="col-w-md">Policy Stage</th>
              <th className="col-w-md">Status</th>
              <th className="col-w-lg">Partners</th>
              <th className="col-w-lg">Policy Progress Score</th>
              <th className="col-w-md">Progress Rating</th>
              <th className="col-w-md">Policy Info</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(data) && data.length > 0
              ? data.map((policy, idx) => (
                <tr key={idx}>
                  <td scope="row" className="col-w-lg fix-col">{policy.country?.long_name || "Test Location"}</td>
                  <td className="col-w-lg fix-col-1">
                    <a href={`/policy/${policy.id}`} target="_blank" rel="noopener noreferrer" className="flex items-start">
                      <span className="arrow-icon">↗</span>
                      <p className="text-green-700">{policy.name.replaceAll('_', ' ')}</p>
                    </a>
                  </td>
                  <td className="col-w-lg">
                    <ul style={{ padding: 0, margin: 0, listStyleType: "none" }}>
                      {policy.policy_systems.map((system) => (
                        <li key={system.system_id}>{system.system.name}</li>
                      ))}
                    </ul>
                  </td>
                  <td className="col-w-md">{policy.stage?.name || "N/A"}</td>
                  <td className="col-w-md">
                    {policy.is_complete && <span className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset">Complete</span>}
                    {policy.is_off_track && <span className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset">Off Track</span>}
                    {policy.is_delayed && <span className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset">Delayed</span>}
                  </td>
                  <td className="col-w-lg">
                    <PartnersDropdown partners={policy.policy_partners} />
                  </td>
                  <td className="col-w-lg">{policy.average_score}</td>
                  <td className="col-w-md"><ProgressRating value={policy.average_score} /></td>
                  <td className="col-w-md">
                    <div className="flex items-center space-x-1">
                      <FaFileAlt
                        style={{ cursor: "pointer", color: "#036f36" }}
                        onClick={() => openSidebar(policy)}
                      />
                      <span
                        style={{ cursor: "pointer", color: "#036f36" }}
                        onClick={() => openSidebar(policy)}
                      >
                          View Details
                      </span>
                    </div>
                  </td>
                </tr>
                ))
              : null}
          </tbody>
        </table>
      </div>

      {isSidebarOpen && selectedPolicy && (
        <Sidebar policy={selectedPolicy} onClose={closeSidebar} alert={alert} />
      )}
    </>
  );
};

export default function PolicyDirectoryManagement({ alert }) {
  document.title = "Policy Directory";

  return (
    <div className="page-content">
      <Policies alert={alert} />
    </div>
  );
}